import { Component, OnInit } from '@angular/core';

import { CloudData, CloudOptions } from 'angular-tag-cloud-module';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { HelpCenterService } from '../help-center-article/help-center-article.service';

@Component({
  selector: 'ngx-help-center-search-history',
  templateUrl: './help-center-search-history.component.html',
  styleUrls: ['./help-center-search-history.component.scss']
})
export class HelpCenterSearchHistoryComponent implements OnInit {

  private color: string[] = ['#d32f2f', '#d81b60', '#ab47bc', '#7e57c2', '#311b92', '#1976d2', '#00838f', '#2e7d32', '#827717', '#bf360c', '#795548', '#757575', '#546e7a'];

  public dataHasResult: CloudData[] = []
  public dataNoResult: CloudData[] = []
  public loadingHasResult: boolean;
  public loadingNoResult: boolean;
  public dateRange;
  bsValue = new Date();
  maxDate = new Date();
  seactObject: any = {};

  amountDataHasResult;
  amountDataNoResult;

  constructor(private helpCenterService: HelpCenterService,
    private localeService: BsLocaleService) {
    this.localeService.use("pt-br");
  }

  ngOnInit() {
    this.maxDate.setDate(this.maxDate.getDate() - 30);
    this.dateRange = [this.maxDate, this.bsValue];
  }

  search() {
    this.loadingHasResult = true;
    this.seactObject.hasResult = true;

    this.dataHasResult = [];
    this.dataNoResult = [];

    this.helpCenterService.searchHistory(this.seactObject).toPromise().then(response => {
      
      response.body.forEach(s => {
        let weight = s.amount;
        if (weight > 20) {
          weight = 20;
        }
        this.dataHasResult.push({ text: s.term + ' (' + s.amount + ')', weight: weight, color: this.color[Math.floor(Math.random() * 12) + 0] })
      })
      this.amountDataHasResult = response.body.reduce(function (a,b) { return a + b.amount; }, 0);

      this.loadingHasResult = false;
    }).catch(() => {
      this.loadingHasResult = false;
    });
    this.seactObject.hasResult = false;
    this.loadingNoResult = true;
    this.helpCenterService.searchHistory(this.seactObject).toPromise().then(response => {
      response.body.forEach(s => {
        let weight = s.amount;
        if (weight > 20) {
          weight = 20;
        }
        this.dataNoResult.push({ text: s.term + ' (' + s.amount + ')', weight: weight, color: this.color[Math.floor(Math.random() * 12) + 0] })
      });
      this.amountDataNoResult = response.body.reduce(function (a,b) { return a + b.amount; }, 0);
      this.loadingNoResult = false;
    }).catch(() => {
      this.loadingNoResult = false;
    });
  }

  options: CloudOptions = {
    width: 1,
    height: 500,
    overflow: true,
    realignOnResize: true,
    randomizeAngle: true,
    zoomOnHover: { scale: 1.1 }
  };

  modelChanged(event) {
    this.dateRange = event;
    this.seactObject.initDate = this.dateRange[0];
    this.seactObject.endDate = this.dateRange[1];
    this.search();
  }

}
